import React from 'react';

const Services = () => {
  return (
    <div>
      <h2>Our Services</h2>
      <ol>
        <li>Property Sales</li>
        <li>Property Management</li>
      </ol>
    </div>
  );
};

export default Services;
